<div class="summary__row">
  <div class="summary__col">{{label}}</div>
  <div class="summary__col"><ng-content></ng-content></div>
</div>
